var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import layoutComponentsDictionary from "../../layout/layoutComponentsDictionary";
import { FormComponentButtons } from "../../formComponentButtons";
import InlineEdit from "@/components/forms/components/basic/etc-field/inlineEdit";
import "./settings";
import "./list";
import copy from "fast-copy";
import { useTranslation } from "react-i18next";
/**
 * Header edit component
 *
 * @param param0
 */
export function EtcField(_a) {
    var moduleName = _a.moduleName, fieldDefs = _a.fieldDefs, record = _a.record, onHandleUpdate = _a.onHandleUpdate, validations = _a.validations, isStudioField = _a.isStudioField, isSelected = _a.isSelected, layoutParent = _a.layoutParent, viewScreen = _a.viewScreen, meta = _a.meta;
    //translator
    var t = useTranslation([moduleName]).t;
    var _b = useState([]), editedRecord = _b[0], setEditedRecord = _b[1];
    useEffect(function () {
        setEditedRecord(Object.keys(record).length === 0
            ? createNewRecord(fieldDefs)
            : copy(record));
    }, [record]);
    // Get updated field
    var fieldIsUpdated = function (field, value) {
        var _a, _b;
        setEditedRecord(__assign(__assign({}, editedRecord), (_a = {}, _a[field] = value, _a)));
        onHandleUpdate && onHandleUpdate(__assign(__assign({}, editedRecord), (_b = {}, _b[field] = value, _b)));
    };
    var fieldName = meta && meta.settings.field ? meta.settings.field : "";
    var fieldDef = fieldDefs && fieldDefs[fieldName] ? fieldDefs[fieldName] : {};
    var fieldLabel = fieldDef.vname ? t(fieldDef.vname) : meta.settings.label;
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "relative" }, { children: [_jsx(InlineEdit, { name: fieldName, record: editedRecord, module: moduleName, label: fieldLabel, fieldMetadata: fieldDef, fieldDefs: fieldDefs, fieldIsUpdated: fieldIsUpdated, validations: validations, fieldSettings: meta && meta, isStudioField: isStudioField, isSelected: isSelected, layoutParent: layoutParent, viewScreen: viewScreen }), isStudioField && (_jsx(_Fragment, { children: _jsx(FormComponentButtons, { parentId: layoutParent, meta: (meta && meta) || [], isLayout: false, isSelected: meta && isSelected === meta.id }) }))] })) }));
}
/**
 * Création de nouveau enregistrement
 * @param r
 * @param fieldDefs
 * @returns
 */
function createNewRecord(fieldDefs) {
    var record = {};
    var fields = Object.keys(fieldDefs);
    fields.forEach(function (field) {
        record[field] = "";
    });
    return record;
}
layoutComponentsDictionary.registerLayoutComponent("etc-field", EtcField);
